import script from "./EtiquetaView.vue?vue&type=script&setup=true&lang=js"
export * from "./EtiquetaView.vue?vue&type=script&setup=true&lang=js"

import "./EtiquetaView.vue?vue&type=style&index=0&id=211b3b67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211b3b67"]])

export default __exports__